import styled, { css } from 'styled-components';

import { Content, ContentMobile, Warning } from '../../../_settings/typography';

export const Wrapper = styled.div.attrs({
  className: 'resume',
})`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({ theme }) =>
    theme.colors[theme.components.cart.wrapperBackground]};
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) =>
    theme.colors[theme.components.cart.wrapperBackground]};
  padding: 0 95px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

export const Header = styled.div.attrs({
  className: 'resume__header',
})`
  ${Content};
  color: ${({ theme }) => theme.colors[theme.components.cart.resumeTextColor]};
  line-height: 1;

  width: 100%;
  display: flex;
  border-bottom: 1px solid var(--formBorder);
  margin-bottom: 26px;
  padding: 80px 0 22px;
  font-weight: bold;

  @media (max-width: 768px) {
    font-weight: bold;

    margin-bottom: 24px;
    padding: 40px 0 8px;
  }
`;

export const Column = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${(props) => (props.rightAlign ? 'flex-end' : 'flex-start')};
  align-items: center;

  &:nth-child(1) {
    max-width: 60%;

    @media (max-width: 768px) {
      max-width: 50%;
      padding-right: 15px;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &:nth-child(2) {
    max-width: 20%;

    @media (max-width: 768px) {
      max-width: 50%;
      padding-left: 15px;
    }
  }

  &:nth-child(3) {
    max-width: 20%;

    @media (max-width: 768px) {
      display: none;
    }
  }
`;

export const Product = styled.div.attrs({
  className: 'resume__item',
})`
  ${Content};
  color: ${({ theme }) => theme.colors[theme.components.cart.resumeTextColor]};

  width: 100%;
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid var(--formBorder);
  margin-bottom: 26px;
  padding: 0 0 21px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    ${ContentMobile};
    color: ${({ theme }) =>
      theme.colors[theme.components.cart.resumeTextColor]};
    line-height: normal;

    margin-bottom: 20px;

    ${Column} {
      &:nth-child(2) {
        align-items: flex-start;
      }

      &:nth-child(3) {
        display: flex;
        justify-content: space-between;
        max-width: 100%;
        margin-top: 40px;

        &::before {
          content: 'Valor';
        }
      }
    }
  }
`;

export const ProductTitle = styled.p`
  ${ContentMobile};
  color: ${({ theme }) => theme.colors[theme.components.cart.resumeTextColor]};
  margin-left: 30px;
  text-align: left;
  line-height: 1.43;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

export const QuantityWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const QuantityButton = styled.button`
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  background: none;
  border: none;

  & > svg {
    path {
      fill: ${(props) =>
        props.disabled ? 'var(--formBorder)' : 'var(--content)'};
    }
    circle {
      stroke: ${(props) =>
        props.disabled ? 'var(--formBorder)' : 'var(--content)'};
    }

    &:hover {
      path {
        fill: ${(props) =>
          props.disabled ? 'var(--formBorder)' : 'var(--main)'};
      }
      circle {
        stroke: ${(props) =>
          props.disabled ? 'var(--formBorder)' : 'var(--main)'};
      }
    }
  }
`;

export const QuantityBox = styled.div.attrs({
  className: 'quantity-box',
})`
  ${({ theme }) => css`
    margin: 0 8px;
    width: 56px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--formBorder);
    user-select: none;
    font-weight: bolder;

    ${theme?.components?.cart?.quantityBox?.borderRadius &&
    css`
      border-radius: ${theme.components.cart.quantityBox.borderRadius}px;
    `}
  `};
`;

export const DeleteItem = styled.div`
  ${Warning};

  user-select: none;
  color: ${({ theme }) => theme.colors[theme.components.cart.removeTextColor]};
  cursor: pointer;
`;

export const Footer = styled.div.attrs({
  className: 'resume__footer',
})`
  ${Content};
  color: ${({ theme }) => theme.colors[theme.components.cart.resumeTextColor]};
  line-height: normal;
  font-weight: bold;

  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--formBorder);
  margin-bottom: 80px;
  padding: 0 0 21px;

  @media (max-width: 768px) {
    padding: 0 0 40px;
  }

  @media (max-width: 768px) {
    ${ContentMobile};
    border: none;
    margin-bottom: 0;
    font-weight: bold;
    color: ${({ theme }) =>
      theme.colors[theme.components.cart.resumeTextColor]};

    ${Column} {
      &:nth-child(1) {
        display: none;
      }

      &:nth-child(2) {
        max-width: 50%;
        padding-left: 0;
        font-weight: bold;
      }

      &:nth-child(3) {
        max-width: 50%;
        display: flex;
        font-weight: bold;
      }
    }
  }
`;
